export default function RequiredLabel({ children, required }) {
  return (
    <span>
      {children}
      {required && <span className="text-red-600 ml-0.5">*</span>}
    </span>
  );
} 